import { render, staticRenderFns } from "./businessDialog.vue?vue&type=template&id=5a5fedb3&scoped=true&"
import script from "./businessDialog.vue?vue&type=script&lang=js&"
export * from "./businessDialog.vue?vue&type=script&lang=js&"
import style0 from "./businessDialog.vue?vue&type=style&index=0&id=5a5fedb3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5fedb3",
  null
  
)

export default component.exports